module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../node_modules/happypack/loader.js?id=jsx!./AppMgmtView.jsx"));
	}, "AppMgmt");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=AppMgmt!./src/pages/bundle-appResource-mgmt/AppMgmt/AppMgmtView.jsx
// module id = ./node_modules/bundle-loader/index.js?lazy&name=AppMgmt!./src/pages/bundle-appResource-mgmt/AppMgmt/AppMgmtView.jsx
// module chunks = 43